import { Users, Heart, ShieldCheck, ChevronRight, Share2, XCircle } from "lucide-react";

export function Home({ scope, heroImg, filtersActive, onShowWorld, onChangeWhereWhen, onClearFilters, onShare }) {
  return (
    <div data-testid="subscriber-home">
      {/* Two-column hero: copy on the left, secondary landscape image on the right */}
      <section className="ww-hero">
        <div className="ww-hero-copy">
          <h1 className="ww-display">A world of joy,<br />freely shared.</h1>
          <p className="ww-hero-sub">
            Somewhere in the world, somebody has captured a moment worth sharing.
          </p>
          <button className="ww-btn ww-btn-primary ww-btn-lg" data-testid="show-me-the-world" onClick={onShowWorld}>
            Show Me The World
          </button>
          <div className="ww-hero-scope">
            <div className="ww-scope-line" data-testid="home-scope">
              <b>{scope.geo}</b><span className="ww-scope-dot">·</span><b>{scope.when}</b>
            </div>
            <div className="ww-scope-actions">
              <button className="ww-change-link" data-testid="home-change-where-when" onClick={onChangeWhereWhen}>
                Change where &amp; when <ChevronRight size={15} />
              </button>
              <button className="ww-clear-link" data-testid="home-clear-filters" onClick={onClearFilters} disabled={!filtersActive}>
                <XCircle size={14} /> Clear all filters
              </button>
            </div>
          </div>
        </div>
        <div className="ww-hero-media" data-testid="home-hero-image">
          <img src={heroImg} alt="Travellers pausing to admire a warm coastal town at golden hour" />
        </div>
      </section>

      <section className="ww-values">
        <div className="ww-value">
          <Users size={20} className="ww-value-ico" strokeWidth={1.6} />
          <div><h2 className="ww-value-h">People, places and moments of joy</h2><p>Photographs of people, families, landscapes, cities and everyday moments.</p></div>
        </div>
        <div className="ww-value">
          <Heart size={20} className="ww-value-ico" strokeWidth={1.6} />
          <div><h2 className="ww-value-h">Democratising joy</h2><p>Everyone can share. Everyone can enjoy.</p></div>
        </div>
        <div className="ww-value">
          <ShieldCheck size={20} className="ww-value-ico" strokeWidth={1.6} />
          <div><h2 className="ww-value-h">Safe &amp; respectful</h2><p>Human moderation. Family friendly.</p></div>
        </div>
        <div className="ww-values-spacer" />
        <button className="ww-btn ww-btn-ghost" data-testid="home-share-some-joy" onClick={onShare}>
          <Share2 size={15} /> Share some joy
        </button>
      </section>
    </div>
  );
}
